var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	54183: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(6929), __webpack_require__.e(494), __webpack_require__.e(8429), __webpack_require__.e(2076), __webpack_require__.e(4087)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 64087))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	24853: {
		fallback: () => (Promise.all([__webpack_require__.e(3440), __webpack_require__.e(4029), __webpack_require__.e(7671)]).then(() => (() => (__webpack_require__(/*! rxjs */ 37671))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	46929: {
		fallback: () => (Promise.all([__webpack_require__.e(3440), __webpack_require__.e(4029), __webpack_require__.e(9029)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 99029))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	96774: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(8046)]).then(() => (() => (__webpack_require__(/*! @angular/common */ 48046))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	42848: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(6929), __webpack_require__.e(6774), __webpack_require__.e(2700), __webpack_require__.e(7966), __webpack_require__.e(4548)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 47234))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/a11y",

	},
	21939: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(6929), __webpack_require__.e(6774), __webpack_require__.e(5117)]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 15117))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	50126: {
		fallback: () => (Promise.all([__webpack_require__.e(6774), __webpack_require__.e(5411)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 95411))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",

	},
	48360: {
		fallback: () => (Promise.all([__webpack_require__.e(6774), __webpack_require__.e(5411), __webpack_require__.e(4788), __webpack_require__.e(2956), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 89126))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",

	},
	62700: {
		fallback: () => (Promise.all([__webpack_require__.e(6774), __webpack_require__.e(5718), __webpack_require__.e(6536), __webpack_require__.e(4581)]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 94581))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	6536: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(6929), __webpack_require__.e(7421)]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 37421))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	31806: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(6929), __webpack_require__.e(6774), __webpack_require__.e(2700), __webpack_require__.e(2444)]).then(() => (() => (__webpack_require__(/*! @angular/router */ 12444))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	27715: {
		fallback: () => (__webpack_require__.e(3300).then(() => (() => (__webpack_require__(/*! @ngrx/signals */ 83300))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals",

	},
	93656: {
		fallback: () => (__webpack_require__.e(2441).then(() => (() => (__webpack_require__(/*! moment */ 52441))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.24.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "moment",

	},
	54326: {
		fallback: () => (__webpack_require__.e(6594).then(() => (() => (__webpack_require__(/*! @agero/js-identity */ 36594))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.3.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@agero/js-identity",

	},
	33751: {
		fallback: () => (Promise.all([__webpack_require__.e(494), __webpack_require__.e(8429), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 94745))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	17403: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(5960), __webpack_require__.e(2320), __webpack_require__.e(932), __webpack_require__.e(9240), __webpack_require__.e(6293), __webpack_require__.e(727), __webpack_require__.e(3146)]).then(() => (() => (__webpack_require__(/*! @angular/material/autocomplete */ 3146))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/autocomplete",

	},
	50619: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(6378), __webpack_require__.e(4152)]).then(() => (() => (__webpack_require__(/*! @angular/material/button */ 76378))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/button",

	},
	67835: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(3924)]).then(() => (() => (__webpack_require__(/*! @angular/material/card */ 43924))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/card",

	},
	13145: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(4293)]).then(() => (() => (__webpack_require__(/*! @angular/material/checkbox */ 24293))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/checkbox",

	},
	93211: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(5960), __webpack_require__.e(932), __webpack_require__.e(9240), __webpack_require__.e(2559)]).then(() => (() => (__webpack_require__(/*! @angular/material/chips */ 42559))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/chips",

	},
	73869: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(5960), __webpack_require__.e(6293), __webpack_require__.e(727), __webpack_require__.e(4587)]).then(() => (() => (__webpack_require__(/*! @angular/material/core */ 64587))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/core",

	},
	23487: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(5960), __webpack_require__.e(2320), __webpack_require__.e(932), __webpack_require__.e(9240), __webpack_require__.e(6378), __webpack_require__.e(8570), __webpack_require__.e(9221)]).then(() => (() => (__webpack_require__(/*! @angular/material/datepicker */ 65044))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/datepicker",

	},
	63779: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(5960), __webpack_require__.e(2320), __webpack_require__.e(3758)]).then(() => (() => (__webpack_require__(/*! @angular/material/dialog */ 73758))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/dialog",

	},
	48691: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(6562), __webpack_require__.e(5960), __webpack_require__.e(2320), __webpack_require__.e(9390), __webpack_require__.e(4993)]).then(() => (() => (__webpack_require__(/*! @angular/material/expansion */ 94993))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/expansion",

	},
	87717: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(932), __webpack_require__.e(9240), __webpack_require__.e(3210), __webpack_require__.e(8607)]).then(() => (() => (__webpack_require__(/*! @angular/material/form-field */ 58687))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/form-field",

	},
	11785: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(6562), __webpack_require__.e(3397)]).then(() => (() => (__webpack_require__(/*! @angular/material/icon */ 93397))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/icon",

	},
	18107: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(932), __webpack_require__.e(9240), __webpack_require__.e(3210), __webpack_require__.e(5708), __webpack_require__.e(2874)]).then(() => (() => (__webpack_require__(/*! @angular/material/input */ 5290))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/input",

	},
	17411: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(5960), __webpack_require__.e(3210), __webpack_require__.e(9390), __webpack_require__.e(6293), __webpack_require__.e(6230)]).then(() => (() => (__webpack_require__(/*! @angular/material/list */ 66230))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/list",

	},
	23433: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(5960), __webpack_require__.e(2320), __webpack_require__.e(3475)]).then(() => (() => (__webpack_require__(/*! @angular/material/menu */ 13475))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/menu",

	},
	61263: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(5960), __webpack_require__.e(2320), __webpack_require__.e(932), __webpack_require__.e(9240), __webpack_require__.e(3210), __webpack_require__.e(9390), __webpack_require__.e(6293), __webpack_require__.e(6378), __webpack_require__.e(727), __webpack_require__.e(8570), __webpack_require__.e(4838), __webpack_require__.e(591)]).then(() => (() => (__webpack_require__(/*! @angular/material/paginator */ 591))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/paginator",

	},
	9649: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(9631)]).then(() => (() => (__webpack_require__(/*! @angular/material/progress-bar */ 39631))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/progress-bar",

	},
	99381: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(6919)]).then(() => (() => (__webpack_require__(/*! @angular/material/progress-spinner */ 26919))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/progress-spinner",

	},
	90947: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(9390), __webpack_require__.e(1959)]).then(() => (() => (__webpack_require__(/*! @angular/material/radio */ 81959))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/radio",

	},
	76755: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(5960), __webpack_require__.e(932), __webpack_require__.e(9240), __webpack_require__.e(3210), __webpack_require__.e(9390), __webpack_require__.e(6293), __webpack_require__.e(727), __webpack_require__.e(4838)]).then(() => (() => (__webpack_require__(/*! @angular/material/select */ 94838))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/select",

	},
	42811: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(5960), __webpack_require__.e(1834)]).then(() => (() => (__webpack_require__(/*! @angular/material/sidenav */ 1834))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/sidenav",

	},
	4603: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(4522)]).then(() => (() => (__webpack_require__(/*! @angular/material/slide-toggle */ 34522))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/slide-toggle",

	},
	47719: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(2320), __webpack_require__.e(6378), __webpack_require__.e(3511)]).then(() => (() => (__webpack_require__(/*! @angular/material/snack-bar */ 11472))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/snack-bar",

	},
	63035: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(6562), __webpack_require__.e(5960), __webpack_require__.e(3376), __webpack_require__.e(1714)]).then(() => (() => (__webpack_require__(/*! @angular/material/sort */ 71714))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/sort",

	},
	71819: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(8696), __webpack_require__.e(9390), __webpack_require__.e(3376), __webpack_require__.e(9418)]).then(() => (() => (__webpack_require__(/*! @angular/material/table */ 69418))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/table",

	},
	43579: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(6562), __webpack_require__.e(4417), __webpack_require__.e(5960), __webpack_require__.e(2320), __webpack_require__.e(932), __webpack_require__.e(3210), __webpack_require__.e(9930)]).then(() => (() => (__webpack_require__(/*! @angular/material/tabs */ 89930))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/tabs",

	},
	77279: {
		fallback: () => (Promise.all([__webpack_require__.e(8004), __webpack_require__.e(2732), __webpack_require__.e(8696), __webpack_require__.e(8756), __webpack_require__.e(5960), __webpack_require__.e(2320), __webpack_require__.e(8570), __webpack_require__.e(3007)]).then(() => (() => (__webpack_require__(/*! @angular/material/tooltip */ 76239))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/tooltip",

	},
	35279: {
		fallback: () => (Promise.all([__webpack_require__.e(5718), __webpack_require__.e(6581), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser/animations */ 84462))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",

	},
	81265: {
		fallback: () => (__webpack_require__.e(4964).then(() => (() => (__webpack_require__(/*! @ng-idle/core */ 94964))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ng-idle/core",

	},
	94628: {
		fallback: () => (__webpack_require__.e(5948).then(() => (() => (__webpack_require__(/*! moment-timezone */ 95948))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^0.6.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "moment-timezone",

	},
	7124: {
		fallback: () => (__webpack_require__.e(7773).then(() => (() => (__webpack_require__(/*! ngx-mask */ 57773))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^16.4.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-mask",

	},
	69953: {
		fallback: () => (Promise.all([__webpack_require__.e(3440), __webpack_require__.e(7567)]).then(() => (() => (__webpack_require__(/*! rxjs/webSocket */ 77567))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/webSocket",

	},
	18272: {
		fallback: () => (__webpack_require__.e(2616).then(() => (() => (__webpack_require__(/*! ui-kit-components */ 12616))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "ui-kit-components",

	},
	91361: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 65412))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	61985: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 60228))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	38004: {
		fallback: () => (__webpack_require__.e(2215).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 24596))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/bidi",

	},
	32732: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(6929), __webpack_require__.e(6774), __webpack_require__.e(2076), __webpack_require__.e(3797)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 22164))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/layout",

	},
	38696: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(1849)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 29354))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/coercion",

	},
	78756: {
		fallback: () => (Promise.all([__webpack_require__.e(6774), __webpack_require__.e(2076), __webpack_require__.e(6894)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 21543))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/platform",

	},
	46562: {
		fallback: () => (__webpack_require__.e(6772).then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 34391))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/private",

	},
	35960: {
		fallback: () => (__webpack_require__.e(459).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 50459))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/keycodes",

	},
	22320: {
		fallback: () => (__webpack_require__.e(4788).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 94788))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/portal",

	},
	90932: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 7949))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers/private",

	},
	62240: {
		fallback: () => (Promise.all([__webpack_require__.e(6774), __webpack_require__.e(5411), __webpack_require__.e(2700), __webpack_require__.e(4788), __webpack_require__.e(2956), __webpack_require__.e(7966), __webpack_require__.e(4454)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 94454))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/dialog",

	},
	9390: {
		fallback: () => (Promise.all([__webpack_require__.e(4853), __webpack_require__.e(5457)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 65457))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/collections",

	},
	86288: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(4139)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 41888))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/accordion",

	},
	3210: {
		fallback: () => (__webpack_require__.e(5508).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 63127))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers",

	},
	25708: {
		fallback: () => (__webpack_require__.e(5984).then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 75984))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/text-field",

	},
	73376: {
		fallback: () => (Promise.all([__webpack_require__.e(6929), __webpack_require__.e(6774), __webpack_require__.e(5411), __webpack_require__.e(6050)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/table */ 56050))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/table",

	},
	86581: {
		fallback: () => (__webpack_require__.e(9880).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 59880))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	82659: {
		fallback: () => (__webpack_require__.e(8465).then(() => (() => (__webpack_require__(/*! @angular/animations */ 88465))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations",

	},
	33692: {
		fallback: () => (__webpack_require__.e(9032).then(() => (() => (__webpack_require__(/*! @angular/google-maps */ 59032))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.14",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/google-maps",

	},
	25552: {
		fallback: () => (__webpack_require__.e(1348).then(() => (() => (__webpack_require__(/*! file-saver */ 61348))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "file-saver",

	},
	73973: {
		fallback: () => (__webpack_require__.e(1585).then(() => (() => (__webpack_require__(/*! jszip */ 31585))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.10.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "jszip",

	},
	31433: {
		fallback: () => (__webpack_require__.e(3442).then(() => (() => (__webpack_require__(/*! lodash */ 13442))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.17.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lodash",

	},
	90388: {
		fallback: () => (__webpack_require__.e(1011).then(() => (() => (__webpack_require__(/*! zod */ 21011))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "zod",

	},
	47101: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! feature-list-state */ 98849))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "feature-list-state",

	},
	68004: {
		fallback: () => (__webpack_require__.e(1018).then(() => (() => (__webpack_require__(/*! ckeditor4-angular */ 11018))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.2.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ckeditor4-angular",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"126": [
		50126
	],
	"932": [
		90932
	],
	"1488": [
		54326,
		33751,
		17403,
		50619,
		67835,
		13145,
		93211,
		73869,
		23487,
		63779,
		48691,
		87717,
		11785,
		18107,
		17411,
		23433,
		61263,
		9649,
		99381,
		90947,
		76755,
		42811,
		4603,
		47719,
		63035,
		71819,
		43579,
		77279,
		35279,
		81265,
		94628,
		7124,
		69953,
		18272
	],
	"1939": [
		21939
	],
	"2320": [
		22320
	],
	"2336": [
		31806,
		27715
	],
	"2582": [
		82659,
		33692,
		25552,
		73973,
		31433,
		90388
	],
	"2700": [
		62700
	],
	"2732": [
		32732
	],
	"2848": [
		42848
	],
	"3210": [
		3210
	],
	"3376": [
		73376
	],
	"3656": [
		93656
	],
	"3758": [
		62240
	],
	"4183": [
		54183
	],
	"4853": [
		24853
	],
	"4993": [
		86288
	],
	"5708": [
		25708
	],
	"5960": [
		35960
	],
	"6536": [
		6536
	],
	"6562": [
		46562
	],
	"6581": [
		86581
	],
	"6644": [
		47101
	],
	"6774": [
		96774
	],
	"6929": [
		46929
	],
	"8004": [
		38004
	],
	"8360": [
		48360
	],
	"8429": [
		91361,
		61985
	],
	"8696": [
		38696
	],
	"8756": [
		78756
	],
	"9390": [
		9390
	],
	"9811": [
		68004
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}